import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import _ from 'lodash'
import { isLoginCheck, loadBillingContact, saveBillingContact, purchase } from '../actions/actions'
import Card from './Card'
import { getShoopingCart, getShoopingCartNumber, clearShoppingCart, removeShoppingCart } from '../functions/shopping-cart'
import LogoLittleShooting from './common/Logo-LittleShooting'
import moment from 'moment'


var getPart = function(components, types) {
	var res = []
	_.forEach(types, type => {
		var val = _.find(components, c => _.find(c.types, t => t === type))
		if(val) {
			res.push(val.long_name)
		}
	})
	return res.join(" ")
}

var getSavedPlaceObject = function() {
	if (localStorage.currentAddress) {
		try {
			const addr = JSON.parse(localStorage.currentAddress)

			return addr
		} catch(e) {
			return undefined
		}
	}
}

class Purchase extends Component {
	state = {
		scrollY: this.props.scrollY,
		scrolling: this.props.scrolling,
		step: getShoopingCartNumber() > 0 ? 1 : 0,
		// step: 0,
		contact: null,
		shoppingCart: this.transformShoppingCart(),
		place: this.getSavedPlace(),
		date: this.getSelectedDay()
	}

	getSavedPlace() {
		const obj = getSavedPlaceObject()
		return obj && obj.formatted_address
	}

	getSelectedDay() {
		if (localStorage.selectedDay) {
			try {
				let selectedDay = moment(localStorage.selectedDay)

				if (selectedDay.isBefore(moment())) {
					return undefined

				}
				document.selectedDay = selectedDay

				return selectedDay.toDate()
			} catch(e) {
				return undefined
			}
		}
	}

	componentWillUnmount = () => {
	    window.removeEventListener('scroll', this.handleScroll);
	}

	transformShoppingCart() {
		let shoppingCart = _.groupBy(getShoopingCart())

		return _.map(shoppingCart, (v, offer_id) => ({offer_id, quantity: _.size(v)}))
	}

	cleanShoppingCart = () => {
		let update = false
		if (!_.isEmpty(this.props.offers)) {
			_.forEach(this.state.shoppingCart, ({offer_id, quantity}) => {
				if (!_.find(this.props.offers, o => o.offer_id == offer_id)) {
					removeShoppingCart(offer_id, quantity)
					update = true
				}
			})
		}
		if (update) {
			this.setState({shoppingCart: this.transformShoppingCart()})
		}
	}

	componentWillMount = () => {
		isLoginCheck().catch(err => {
			this.props.history.replace("/login?goto=purchase")
		})
		loadBillingContact().then(contact => {
			console.log("contact", contact)
			const currentAddress = getSavedPlaceObject()
			if( !contact.zipcode && !contact.city && currentAddress && currentAddress.address_components) {
				//On ajoute l'adresse de livraison comme adresse de facturation par défaut s'il n'est pas déjà présente dans le compte
				var delContact = {}
				var components = currentAddress.address_components
				delContact.address_line1 = getPart(components, ["street_number", "route"])
				delContact.zipcode = getPart(components, ["postal_code"])
				delContact.city = getPart(components, ["locality"])
				this.setState({contact: _.defaults(delContact, contact)})
			} else {
				this.setState({contact})
			}
		})
	}

	saveContact = contact => {
		this.setState({contact, step: 2})
	}

	saveTokenAndPaid = token => {
		this.setState({step: 3})
		return purchase(
			this.state.shoppingCart,
			this.state.contact,
			token,
			{place:this.getSavedPlace(), date:this.state.date},
			typeof document ? document.message : ''
		)
		.then(res => {
			this.setState({step: 4})
			clearShoppingCart()
			document.message = null
		})
		.catch(err => {
			console.error(err)
			this.setState({step: 5})
		})
	}

	render () {
		const { step, contact, shoppingCart } = this.state

		return (
			<main id="purchase" className="pos-r w100 flex-container flex-item-noshrink zi4" role="main">
				<section className="tiny-pos-f w40 tiny-w100 color--inverse bgc--primary tiny-pb0 pbxl prl of-hidden">
					<div className="h1-like right tiny-left tiny-w60 small-w80 medium-w80 large-w70 extra-large-w60 tiny-pts ptl pll tiny-prl medium-prl large-prl extra-large-prl">
						<LogoLittleShooting className="logo-littleshooting"/>
						<span className="visually-hidden">Little Shooting</span>
					</div>
					<div className="pos-a mauto w100 tiny-pts ptm pll">
						<img className="w50 tiny-w100 tiny-pt0 large-pll extra-large-plxl ptl flip-h" src="/assets/images/basket.png" alt=""/>
					</div>
				</section>
				{
					step === 0 && contact ?
						<section className="d-flex flex-column flex-space-between w60 tiny-h80 tiny-w100 bgc--inverse large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbm zi1">
							<div className="ptl pbl mtm"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
							<div className="mauto extra-large-w70">
								<h1 className="h3-like mbl">Votre panier est vide</h1>
							</div>
						</section>
					: 	false
				}
				{
					step === 1 && contact ?
						<Contact
							contact={contact}
							nextStep={this.saveContact}
							place={this.getSavedPlace()}
						/>
					: 	false
				}
				{
					step === 2 ?
						<Card
							offers={this.props.offers}
							shoppingCart={shoppingCart}
							nextStep={this.saveTokenAndPaid}
							goBack={() => this.setState({step: 1})}
							cleanShoppingCart={this.cleanShoppingCart}
						/>
					: 	false
				}
				{
					step === 3 || !contact?
						<section className="d-flex flex-column flex-space-between w60 tiny-h80 tiny-w100 bgc--inverse large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbm zi1">
							<div className="h3-like mauto">Traitement en cours…</div>
						</section>
					: 	false
				}
				{
					step === 4 ?
						<section className="d-flex flex-column flex-space-between w60 tiny-h80 tiny-w100 bgc--inverse large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbm zi1">
							<div className="ptl pbl mtm"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
							<div className="mauto extra-large-w70">
								<h1 className="h3-like mbl">Merci</h1>
								<p>
									Votre commande a bien été enregistrée.
								</p>
								<p>
									Vous recevrez une notification dès qu'elle sera prise en compte 
									par le studio photo avec un créneau horaire pour récupérer vos produits.
								</p>
								<p>
									Assurez-vous que vos produits sont prêt dans un emballage adapté pour un transport jusqu'au studio photo.
								</p>
								<p>
									Le service clients est à votre disposition pour répondre à toutes vos questions par email (help@little-shooting.com) 
									ou par téléphone (01 76 35 08 66) du lundi au vendredi de 10h à 18h.
								</p>
							</div>
						</section>
					: 	false
				}
				{
					step === 5 ?
						<section className="d-flex flex-column flex-space-between w60 tiny-h80 tiny-w100 bgc--inverse large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbm zi1">
							<div className="mtm ptl tiny-ptm"><Link className="btn--ghost" to="/">&#60;&nbsp;Retour à la liste des offres</Link></div>
							<div className="mauto extra-large-w70">
								<h1 className="h3-like mbl">Une erreur est survenue</h1>
								<p>
									Veuillez retenter de passer votre commande.
								</p>
							</div>
						</section>
					: 	false
				}
			</main>
		)
	}
}

class Contact extends Component {
	state = _.defaults({saving: false, showError: false}, this.props.contact)
	save = () => {
		const contact = this.state

		if (!contact.firstname
			|| !contact.lastname
			|| !contact.email
			|| !contact.phone
			|| !contact.address_line1
			|| !contact.zipcode
			|| !contact.city
			|| !contact.country) {
			this.setState({showError: true}, () => {
				if(document.querySelectorAll(".input--error")[0])
					document.querySelectorAll(".input--error")[0].scrollIntoView({behavior : "smooth", block : "center"})
			})
		} else {
			this.setState({saving: true})
			saveBillingContact(contact)
			.then(this.props.nextStep)
			.catch(() => this.setState({saving: false}))
		}
	}
	changeTitle = (e) => {
		this.setState({title: e.target.value})
	}
	changeFirstname = (e) => {
		this.setState({firstname: e.target.value})
	}
	changeLastname = (e) => {
		this.setState({lastname: e.target.value})
	}
	changeEmail = (e) => {
		this.setState({email: e.target.value})
	}
	changePhone = (e) => {
		this.setState({phone: e.target.value})
	}
	changeAddress_line1 = (e) => {
		this.setState({address_line1: e.target.value})
	}
	changeAddress_line2 = (e) => {
		this.setState({address_line2: e.target.value})
	}
	changeZipcode = (e) => {
		this.setState({zipcode: e.target.value})
	}
	changeCity = (e) => {
		this.setState({city: e.target.value})
	}
	changeCountry = (e) => {
		this.setState({country: e.target.value})
	}
	render() {
		const { showError } = this.state
		console.log("showError = " + showError)

		return (
			<section className="w60 tiny-w100 bgc--inverse tiny-ptxl large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbl zi1">
				<div className="pll prl">
					<div className="ptl pbl mtm"><Link className="btn--unstyled u-secondary-bold u-big" to="/"><span className="prs">&#60;</span>Retour à la liste des offres</Link></div>
					<div className="pbl">
						<h1 className="h3-like">Contact de paiement</h1>
					</div>
					<form>
						<table>
							<tbody>
								<tr>
									<td className="tiny-w40"><span>Civilité</span></td>
									<td className="tiny-w60 pts pbs">
										<select className="w100" value={this.state.title} onChange={this.changeTitle}>
											<option value={10}>Mme</option>
											<option value={20}>Mr</option>
											<option value={30}>Autre</option>
										</select>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Prénom <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.firstname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un prénom.</span></p>
										<input className={"w100" + (showError && !this.state.firstname ? " input--error" : "")} type="text" value={this.state.firstname || ''} onChange={this.changeFirstname}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Nom <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.lastname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un nom.</span></p>
										<input className={"w100" + (showError && !this.state.lastname ? " input--error" : "")} type="text" value={this.state.lastname || ''} onChange={this.changeLastname}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Email <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.email ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse mail.</span></p>
										<input className={"w100" + (showError && !this.state.email ? " input--error" : "")} type="email" value={this.state.email || ''} onChange={this.changeEmail}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Téléphone <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.phone ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un numéro de téléphone.</span></p>
										<input className={"w100" + (showError && !this.state.phone ? " input--error" : "")} type='tel' value={this.state.phone || ''} onChange={this.changePhone}/>
									</td>
								</tr>
								<tr>
									<td colSpan="2"><h4 className="h4-like ptl pbs">Adresse de retrait des produits</h4></td>
								</tr>
								<tr>
									<td className="pbm" colSpan="2">{this.props.place}</td>
								</tr>
								<tr>
									<td colSpan="2"><h4 className="h4-like ptl pbs">Adresse de facturation</h4></td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Numéro et nom de la voie <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.address_line1 ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse.</span></p>
										<input className={"w100" + (showError && !this.state.address_line1 ? " input--error" : "")} type="text" value={this.state.address_line1 || ''} onChange={this.changeAddress_line1}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Complément d'adresse</span></td>
									<td className="tiny-w60 pts pbs">
										<input className="w100" type="text" value={this.state.address_line2 || ''} onChange={this.changeAddress_line2} />
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Code Postal <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.zipcode ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un code postal.</span></p>
										<input className={"w100" + (showError && !this.state.zipcode ? " input--error" : "")} type="number" value={this.state.zipcode || ''} onChange={this.changeZipcode}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Ville <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.city ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une ville.</span></p>
										<input className={"w100" + (showError && !this.state.city ? " input--error" : "")} type="text" value={this.state.city || ''} onChange={this.changeCity}/>
									</td>
								</tr>
								<tr>
									<td className="tiny-w40"><span>Pays <span className="color--primary-darken">*</span></span></td>
									<td className="tiny-w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.country ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un pays.</span></p>
										<input className={"w100" + (showError && !this.state.country ? " input--error" : "")} type="text" value={this.state.country || ''} onChange={this.changeCountry}/>
									</td>
								</tr>
								<tr>
									<td colSpan="2"><p className="ptm u-small u-italic color--primary-darken">* Informations obligatoires</p></td>
								</tr>
							</tbody>
						</table>
						<div className='w100'>
							<button type='button' className='btn--secondary btn--big fr' disabled={this.state.saving} onClick={this.save}><span className="pll prl">Suivant</span></button>
						</div>
					</form>
				</div>
			</section>
		)
	}
}

export default withRouter(Purchase)


// WEBPACK FOOTER //
// ./src/components/Purchase.js